import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import CombinedCategorySubcategoryOrderSelector from "./CombinedCategorySubcategoryOrderSelector";

const CombinedCategorySubcategoryOrderPage = () => {
  const { userId } = useParams();
  const [searchParams] = useSearchParams();
  const [brandColor, setBrandColor] = useState("#6366f1");
  const [loading, setLoading] = useState(true);
  
  // Get filter parameters - now fetched from backend using buttonId
  const [filterCategoryIds, setFilterCategoryIds] = useState([]);
  const [filterSubCategoryIds, setFilterSubCategoryIds] = useState([]);
  const [buttonId, setButtonId] = useState(null);

  useEffect(() => {
    const buttonIdParam = searchParams.get('buttonId');
    
    if (buttonIdParam) {
      setButtonId(buttonIdParam);
      console.log("Button-specific ordering for buttonId:", buttonIdParam);
      
      // Fetch button configuration from backend
      fetchButtonConfiguration(buttonIdParam);
    } else {
      // No buttonId means global ordering - no filters
      setFilterCategoryIds([]);
      setFilterSubCategoryIds([]);
      setLoading(false);
    }
  }, [searchParams, userId]);

  const fetchButtonConfiguration = async (btnId) => {
    try {
      console.log("Fetching button configuration for buttonId:", btnId);
      const response = await axios.get(`/api/wayfinder-button/config/${userId}/${btnId}`);
      
      if (response.data.success) {
        const { categoryIds, subCategoryIds, hasWayfinderConfig } = response.data.data;
        
        if (hasWayfinderConfig === false) {
          console.warn("Button does not have wayfinder configuration - showing all categories/subcategories");
          setFilterCategoryIds([]);
          setFilterSubCategoryIds([]);
        } else {
          setFilterCategoryIds(categoryIds || []);
          setFilterSubCategoryIds(subCategoryIds || []);
          console.log("Fetched button config - Categories:", categoryIds, "Subcategories:", subCategoryIds);
        }
      } else {
        console.error("Failed to fetch button configuration:", response.data.message);
        // Fallback to showing all categories/subcategories
        setFilterCategoryIds([]);
        setFilterSubCategoryIds([]);
      }
    } catch (error) {
      console.error("Error fetching button configuration:", error);
      // Fallback to showing all categories/subcategories
      setFilterCategoryIds([]);
      setFilterSubCategoryIds([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchBrandColor = async () => {
      try {
        const res = await axios.get(`/auth/aiform/all//${userId}`);
        setBrandColor(res.data?.brand_color || "#6366f1");
      } catch (err) {
        console.error("Error fetching brand color:", err);
      }
    };

    if (userId) {
      fetchBrandColor();
    }
  }, [userId]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#64748b",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <CombinedCategorySubcategoryOrderSelector
      userId={userId}
      brandColor={brandColor}
      title="Order Categories & Subcategories"
      searchPlaceholder="Search categories and subcategories..."
      filterCategoryIds={filterCategoryIds}
      filterSubCategoryIds={filterSubCategoryIds}
      buttonId={buttonId}
    />
  );
};

export default CombinedCategorySubcategoryOrderPage;
